import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useBrandState } from 'src/contexts/BrandContext';

export default function MarketplaceCareitBadge() {
  const { t } = useTranslation('translation');
  const { hasBrand } = useBrandState();

  if (!hasBrand) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{
        py: 1,
        px: 2,
        mb: 2,
        borderRadius: 1,
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
      }}
    >
      <Box
        component="img"
        src="/static/brand/careit_icon.svg"
        alt="Careit"
        sx={{ height: 20, width: 'auto' }}
      />
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {t('marketplace.operated-by-careit')}
      </Typography>
    </Stack>
  );
}
